import { render } from "./SoleTraderWorkStationComponent.vue?vue&type=template&id=3ff8d729&scoped=true&ts=true"
import script from "./SoleTraderWorkStationComponent.vue?vue&type=script&lang=ts"
export * from "./SoleTraderWorkStationComponent.vue?vue&type=script&lang=ts"

import "./SoleTraderWorkStationComponent.vue?vue&type=style&index=0&id=3ff8d729&lang=scss&scoped=true"
import "./SoleTraderWorkStationComponent.vue?vue&type=style&index=1&id=3ff8d729&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ff8d729"]])

export default __exports__